import { type HelpdeskFormMessages, makeAddHelpdeskNoteBody, makeCreateHelpdeskTicketBody } from "@seagames/contracts";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * The helpdesk forms' zod schemas with localized messages (the contracts'
 * message-factory pattern, CLAUDE.md i18n): the same rules the API runs,
 * worded in the viewer's language. Keys: `helpdesk:form.*`.
 */
export function useHelpdeskSchemas() {
	const { t } = useTranslation("helpdesk");
	return useMemo(() => {
		const m: HelpdeskFormMessages = {
			required: t("form.required"),
			textTooLong: t("form.textTooLong"),
			titleRequired: t("form.titleRequired"),
			bodyRequired: t("form.bodyRequired"),
			buildingRequired: t("form.buildingRequired"),
			roomBothGiven: t("form.roomBothGiven"),
			nothingToChange: t("form.nothingToChange"),
		};
		return { create: makeCreateHelpdeskTicketBody(m), note: makeAddHelpdeskNoteBody(m) };
	}, [t]);
}
